import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import BaseModal from "../UI/BaseModal";

const AceptarCancelarModal = ({
  isOpen,
  toggle,
  handleOk,
  handleCancel,
  loading,
  okBtnText,
  cancelBtnText,
  confirmMsg,
}) => {
  const [isAceptarPressed, setIsAceptarPressed] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setIsAceptarPressed(false);
    }
  }, [isOpen]);

  const handleAceptarClick = () => {
    setIsAceptarPressed(true);
    handleOk();
  };

  return (
    <div>
      <BaseModal handleModal={toggle} modalOpen={isOpen} type="cancel-modal">
        <div id="inline-block-container" className="modal-cancel text">
          <div id="inline-block-icon" className="centered-horizontal-container">
            <FontAwesomeIcon icon={faCopy} color="var(--orsan-green)" />
          </div>
          <div
            id="inline-block-message"
            className="cancel-modal-text centered-horizontal-container pt-3 pb-3"
          >
            {confirmMsg}
          </div>
        </div>
        <div className="button-container">
          <div className="centered-horizontal-container">
            <Button
              className="warning-accept"
              disabled={loading || isAceptarPressed}
              onClick={handleAceptarClick}
            >
              {okBtnText}
            </Button>
            <Button
              className="warning-cancel ml-2"
              disabled={isAceptarPressed}
              onClick={() => handleCancel()}
            >
              {cancelBtnText}
            </Button>
          </div>
        </div>
      </BaseModal>
    </div>
  );
};

AceptarCancelarModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  handleOk: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  okBtnText: PropTypes.string,
  cancelBtnText: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  confirmMsg: PropTypes.object.isRequired
};

AceptarCancelarModal.defaultProps = {
  okBtnText: "Aceptar",
  cancelBtnText: "Cancelar",
  loading: false,
};

export default AceptarCancelarModal;
